import React from 'react'
import { useNavigate } from 'react-router-dom';
import Adminnav from '../Adminnav';
const SellerConfig = () => {
    var nav = useNavigate()
  function navAddSeller(){
    nav('/AdminPanel/UserConfig/SellerConfig/AddSeller')
  }
  function navRemoveSeller(){
    nav('/AdminPanel/UserConfig/SellerConfig/RemoveSeller')
  }
  return (
    <>
    <Adminnav/>
    <div className="card h-100 text-center panel" >
                <div className="card-body row ">
                <i className="fas fa-user-plus col icons"  onClick={()=>navAddSeller()}></i>
                <i className="fas fa-user-slash col icons" onClick={()=>navRemoveSeller()}></i>
                </div>
                <div className="card-body row content">
                <b className="col" style={{paddingLeft:"3.0px"}}>Add Seller</b>
                <b className="col" style={{marginLeft:"25px"}}>Remove Seller</b>
                </div>
            </div>
    </>
  )
}

export default SellerConfig